import { MaintenanceWindowPatchManagementVendorProductSelectorBaseDataProvider } from './MaintenanceWindowPatchManagementVendorProductSelectorBaseDataProvider';
import { ProductRecord, VendorRecord } from '../types';

export class MaintenanceWindowPatchManagementVendorProductSelectorGzDataProvider extends MaintenanceWindowPatchManagementVendorProductSelectorBaseDataProvider {
  async getAllVendors(): Promise<VendorRecord[]> {
    const response = await this.dependencies.api.clients.VendorsCatalog.getAllVendors();

    if (!Array.isArray(response.records)) {
      throw new Error('Invalid vendor list');
    }

    return response.records;
  }
  async getProductsForVendor(params: { vendorId: string }): Promise<ProductRecord[]> {
    const response = await this.dependencies.api.clients.ProductsCatalog.getProductsForVendor(params);

    if (!Array.isArray(response.records)) {
      throw new Error('Invalid vendor product list');
    }

    return response.records;
  }
}
